module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_5_a51f39020f7b0671319be43e570271d0.png";